import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { RouterModule } from '@angular/router'
import { BrowserModule } from '@angular/platform-browser'

import { PortalLayoutComponent } from './components/layouts/portal/portal-layout/portal-layout.component';
import { ComponentsModule } from './components/components.module'
import { AppComponent } from './app.component'
import { MainRoutes } from './app.routes';
import { PortalHeaderComponent } from './components/layouts/portal/portal-header/portal-header.component';
import { PortalFooterComponent } from './components/layouts/portal/portal-footer/portal-footer.component';
import { QuoteLayoutComponent } from './components/layouts/quote/quote-layout/quote-layout.component';
import { PortalHeaderMobileComponent } from './components/layouts/portal/portal-header-mobile/portal-header-mobile.component';
import { PortalMenuMobileComponent } from './components/layouts/portal/portal-menu-mobile/portal-menu-mobile.component';
// import { MobileFooter1 } from './components/layouts/portal/portal-footer-mobile/portal-footer-mobile.component';
// import { PortalFooterPageMobileComponent } from './components/layouts/portal/portal-footer-pages-mobile/portal-footer-pages-mobile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './pages/login/login.component';
import { API_BASE_URL } from './service/web-api-client';
import { environment } from 'src/environments/environment';
import { PrivacyStatementComponent } from './pages/privacy-statement/privacy-statement.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { CancellationAndReturnPolicyComponent } from './pages/cancellation-and-return-policy/cancellation-and-return-policy.component';
import { HttpClientModule, HttpClient, provideHttpClient, withFetch } from '@angular/common/http';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HomeComponent } from './pages/home/home.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogDesktopComponent } from './pages/blog/blog-desktop/blog-desktop.component';
import { BlogMobileComponent } from './pages/blog/blog-mobile/blog-mobile.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { BenefitsComponent } from './pages/benefits/benefits.component';
import { InsuredComponent } from './pages/insured/insured.component';
import { QuoteComponent } from './pages/quote/quote.component';
export function HttpLoaderFactory(http:HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    PortalLayoutComponent,
    PortalHeaderComponent,
    PortalHeaderMobileComponent,
    // MobileFooter1,
    PortalMenuMobileComponent,
    PortalFooterComponent,
    // PortalFooterPageMobileComponent,
    QuoteLayoutComponent,
    LoginComponent,
    PrivacyStatementComponent,
    TermsAndConditionsComponent,
    CancellationAndReturnPolicyComponent,
    HomeComponent,
    BlogComponent,
    BlogDesktopComponent,
    BlogMobileComponent,
    AboutUsComponent,
    BenefitsComponent,
    InsuredComponent,
    QuoteComponent
  ],
  imports: [
    BrowserModule, 
    RouterModule.forRoot(MainRoutes, {
			useHash: true,
			scrollPositionRestoration: 'enabled',
			paramsInheritanceStrategy: 'always'
		}),
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [{
    provide: API_BASE_URL,
    useValue: environment.apiBaseUrl
  },
  provideHttpClient(withFetch())
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
